import React, { useContext } from "react";
import FileUpload from "./FileUpload";
import FileUploadCrop from "./FileUploadCrop";
import { FileUploadContext } from "../../../../Providers/FileUploadProvider/FileUploadProvider";
import { TranslationContext } from "../../../../Providers/TranslationProvider";

const FileUploadContainer = props => {
    const { uploadSetting } = useContext(FileUploadContext);
    const {trans} = useContext(TranslationContext)

    switch (uploadSetting) {
        case "4":
            return (
                <>
                    <h5 className="font-bold mb-1">{trans('deliver_files', true)}</h5>
                    <p className="text-sm mb-4">
                        {trans('you_may_add_files', true)}
                    </p>
                    <FileUpload multiple={false} />
                    <small>MAX 100MB, bij voorkeur PDF</small>
                </>
            );
        case "3":
            return (
                <>
                    <h5 className="font-bold mb-1">{trans('deliver_files', true)}</h5>
                    <p className="text-sm mb-4">
                    {trans('you_may_add_files', true)}
                    {trans('after_upload_crop', true)}
                    </p>
                    <FileUploadCrop bleed={false} />
                    <small>MAX 100MB, bij voorkeur PDF</small>
                </>
            );
        case "2":
            return (
                <>
                    <h5 className="font-bold mb-1">{trans('deliver_files', true)}</h5>
                    <p className="text-sm mb-4">
                        {trans('you_may_add_files', true)}
                        {trans('after_upload_crop', true)}

						<br/>
						<b> {trans('alert_crop_section', true)}</b>
                    </p>
                    <FileUploadCrop bleed={true} />
                    <small>MAX 100MB, bij voorkeur PDF</small>
                </>
            );
        default:
            return (
                <>
                    <h5 className="font-bold mb-1">{trans('deliver_files', true)}</h5>
                    <p className="text-sm mb-4">
                        {trans('you_may_add_files', true)}
                    </p>
                    <FileUpload multiple={true} />
                    <small>MAX 100MB, bij voorkeur PDF</small>
                </>
            );
    }
};

export default FileUploadContainer;
